<template>
  <figure class="highcharts-figure">
    <highcharts ref="chart" :options="options" />
    <p class="highcharts-description highcharts-linked-description">
      <strong>Figure : </strong>
      {{ $t('compGraphicsHeatingEmissionFactors.help') }}
    </p>
  </figure>
</template>

<script>
import '@/plugins/highcharts.js'
import HEATING_FACTORS from '@/../data/factors/carbon/heatingFactors.json'

export default {
  name: 'HeatingEmissionFactors',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  computed: {
    series: function () {
      let series = [
        {
          name: this.$t('combustion'),
          data: []
        },
        {
          name: this.$t('upstream'),
          data: []
        }
      ]
      // add naturalgas
      let lastYear = Math.max(
        ...Object.keys(HEATING_FACTORS.gas['naturalgas'].decomposition)
      )
      series[0].data.push(
        HEATING_FACTORS.gas['naturalgas'].decomposition[lastYear].combustion
          .total
      )
      series[1].data.push(
        HEATING_FACTORS.gas['naturalgas'].decomposition[lastYear].upstream.total
      )
      // add propane
      lastYear = Math.max(
        ...Object.keys(HEATING_FACTORS.gas['propane'].decomposition)
      )
      series[0].data.push(
        HEATING_FACTORS.gas['propane'].decomposition[lastYear].combustion.total
      )
      series[1].data.push(
        HEATING_FACTORS.gas['propane'].decomposition[lastYear].upstream.total
      )
      // add heating.oil
      lastYear = Math.max(
        ...Object.keys(
          HEATING_FACTORS['heating.oil']['heating.oil'].decomposition
        )
      )
      series[0].data.push(
        HEATING_FACTORS['heating.oil']['heating.oil'].decomposition[lastYear]
          .combustion.total
      )
      series[1].data.push(
        HEATING_FACTORS['heating.oil']['heating.oil'].decomposition[lastYear]
          .upstream.total
      )
      // add biomethane
      lastYear = Math.max(
        ...Object.keys(HEATING_FACTORS.biomethane['biomethane'].decomposition)
      )
      series[0].data.push(
        HEATING_FACTORS.biomethane['biomethane'].decomposition[lastYear]
          .combustion.total
      )
      series[1].data.push(
        HEATING_FACTORS.biomethane['biomethane'].decomposition[lastYear]
          .upstream.total
      )
      // add wood.pellets
      lastYear = Math.max(
        ...Object.keys(
          HEATING_FACTORS['wood.heating']['wood.pellets'].decomposition
        )
      )
      series[0].data.push(
        HEATING_FACTORS['wood.heating']['wood.pellets'].decomposition[lastYear]
          .combustion.total
      )
      series[1].data.push(
        HEATING_FACTORS['wood.heating']['wood.pellets'].decomposition[lastYear]
          .upstream.total
      )
      // add wood.chips
      lastYear = Math.max(
        ...Object.keys(
          HEATING_FACTORS['wood.heating']['wood.chips'].decomposition
        )
      )
      series[0].data.push(
        HEATING_FACTORS['wood.heating']['wood.chips'].decomposition[lastYear]
          .combustion.total
      )
      series[1].data.push(
        HEATING_FACTORS['wood.heating']['wood.chips'].decomposition[lastYear]
          .upstream.total
      )
      // add wood.logs
      lastYear = Math.max(
        ...Object.keys(
          HEATING_FACTORS['wood.heating']['wood.logs'].decomposition
        )
      )
      series[0].data.push(
        HEATING_FACTORS['wood.heating']['wood.logs'].decomposition[lastYear]
          .combustion.total
      )
      series[1].data.push(
        HEATING_FACTORS['wood.heating']['wood.logs'].decomposition[lastYear]
          .upstream.total
      )
      return series
    },
    categories: function () {
      return [
        this.$t('naturalgas'),
        this.$t('propane'),
        this.$t('heating.oil'),
        this.$t('biomethane'),
        this.$t('wood.pellets'),
        this.$t('wood.chips'),
        this.$t('wood.logs')
      ]
    },
    options: function () {
      let self = this
      return {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: this.categories
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('compGraphicsHeatingEmissionFactors.kg.co2e.lhv')
          }
        },
        tooltip: {
          formatter: function () {
            let tooltip = this.points[0].x + ' <br />'
            for (let i in this.points) {
              tooltip +=
                '<span style="color:' +
                this.points[i].series.color +
                ';">\u25CF ' +
                '</span> '
              tooltip +=
                this.points[i].series.name +
                ': <b>' +
                Math.round(this.points[i].y * 10000) / 10000
              tooltip +=
                '</b> ' +
                self.$t('compGraphicsHeatingEmissionFactors.kg.co2e.lhv') +
                ' <br />'
            }
            return tooltip
          },
          shared: true
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true
            }
          }
        },
        series: this.series
      }
    }
  }
}
</script>

<style scoped>
.highcharts-figure {
  min-width: 320px;
  max-width: 700px;
  margin: 1em auto;
}
.highcharts-description {
  text-align: center;
  color: '#777777';
  font-style: italic;
}
</style>
